export enum RugbyLeaguePenaltyTryAttribute {
  Golden = 2990,
}
